export const countryCodes = [
	{
		id: "denmark",
		orderby: 1,
		code: "+45",
		flag: "../assets/flags/da.png",
		name_translation_key: "Denmark",
		country_code: "DK",
	},
	{
		id: "norway",
		orderby: 1,
		code: "+47",
		flag: "../../assets/flags/no.png",
		name_translation_key: "Norway",
		country_code: "NO",
	},
	{
		id: "sweden",
		orderby: 1,
		code: "+46",
		flag: "..assets\flagsse.png",
		name_translation_key: "Sweden",
		country_code: "SE",
	},
	{
		id: "germany",
		orderby: 1,
		code: "+49",
		flag: "..assets\flagsde.png",
		name_translation_key: "Germany",
		country_code: "DE",
	},
];
